// removed by extract-text-webpack-plugin
module.exports = {"buttonStyles":"buttonStyles___3PL6H","divStyles":"divStyles___2nuAC","titleStyles":"titleStyles___3Ib3J","leftGrid":"leftGrid___1xp7l","centerContent":"centerContent___11dkj"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpDialogTitle.module.less
// module id = 3378
// module chunks = 29